import {
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  TextInput,
  Textarea,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useForm, hasLength } from "@mantine/form";
import { useEffect } from "react";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow, IconX } from "@tabler/icons-react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import Repository from "../../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../../const/apiRoute";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";

interface EditProps {
  item: any;
  onClose: (refresh: boolean) => void;
}

const EditProductCategoryView = ({ item, onClose }: EditProps) => {
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [loading, { open, close }] = useDisclosure(false);

  const form = useForm({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: item,
    validate: {
      title: hasLength({ min: 3 }, "Tên danh mục phải dài hơn 3 ký tự"),
    },
  });
  const handleSubmit = async (values: typeof form.values) => {
    open();

    const res = await repository.post<MessageResponse<boolean>>(
      API_ROUTE.UPDATE_FACEBOOK_AD,
      values
    );

    if (res?.success) {
      NotificationExtension.Success("Cập nhật thành công!");
      onClose(true);
      modals.closeAll();
    } else {
      NotificationExtension.Fails("Cập nhật thất bại.");
    }
    close();
  };

  return (
    <Box
      component="form"
      onSubmit={form.onSubmit(handleSubmit)}
      style={{ position: "relative", width: 500 }}
    >
      <LoadingOverlay visible={loading} />
      {/* <Title order={5} mb={10}>Chỉnh sửa danh mục</Title> */}
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            label="Tên danh mục"
            withAsterisk
            {...form.getInputProps("title")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Google Category ID"
            {...form.getInputProps("googleCategoryId")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea label="Mô tả" {...form.getInputProps("description")} />
        </Grid.Col>
      </Grid>

      <Group
        justify="center"
        mt="xs"
        p="5px 0"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="submit"
          color="blue"
          leftSection={<IconCheck size={16} />}
          loading={loading}
        >
          Cập nhật
        </Button>
        <ButtonClose />
      </Group>
    </Box>
  );
};

export default EditProductCategoryView;
